import React, { useEffect, useState } from "react";
import TextInput from "./../../components/common/ui/Inputs/TextInput";
import SelectInput from "./../../components/common/ui/Inputs/SelectInput";
import Button from "./../../components/common/ui/Button";
import ExcelExport from "./../../components/common/ui/Export/ExcelExport";
import Table from "./../../components/common/table/Table";
import TextAreaInput from "./../../components/common/ui/Inputs/TextAreaInput";
import { useDispatch, useSelector } from "react-redux";
import { dndAction, authActions } from "../../_store";
import CustomLoader from "../../components/common/ui/Loader";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { history } from "../../_helpers";
import generateXlsx from "../../components/common/export/generateXlsx";
import { StoredProcedures } from "../../_helpers/enumerator";
import Swal from "sweetalert2";
import AddIcon from "../../assets/svg/btn_icons/create-btn-icon.svg";
import updateDND from "../../assets/svg/btn_icons/update DND.svg";
import { formatDateTimeAMPM } from "../../utils/formatTime";

function DNDUserList() {
  const dispatch = useDispatch();

  const { DNDInviteType, DNDType, dndStatus } = useSelector(
    (state) => state.dropdownOptions
  );
  const {
    getUserDNDList: userDNDList,
    getTwilioDNDList: userTwilioList,
    loading,
    DNDSearchdata: DNDSearch,
    getTwilioExcelDNDList,
    getUserExcelDNDList,
  } = useSelector((x) => x?.dnd || {});
  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  const [submit, setSubmit] = useState(false);
  const [showSearchFields, setShowSearchFields] = useState(false);

  const [twilioPagination, setTwilioPagination] = useState({
    pageNo: 1,
    rowCountPerPage: 10,
    SortBy: "",
  });
  let dndsorting = false;
  let twiliosorting = false;
  const today = new Date();
  const month = today?.getMonth() + 1;
  const year = today?.getFullYear();
  const date = today?.getDate();

  useEffect(() => {
    getDNDUserList();
  }, [DNDSearch?.pageNo, DNDSearch?.rowCountPerPage]);

  useEffect(() => {
    getTwilioDNDList();
  }, [twilioPagination?.pageNo, twilioPagination?.rowCountPerPage]);

  useEffect(() => {
    if (getTwilioExcelDNDList && getTwilioExcelDNDList?.DataList?.length > 0) {
      let generateExcelColumns = ["Mobile", "Date", "Status"];

      const exportData = getTwilioExcelDNDList?.DataList?.map((obj) => ({
        Mobile: obj.ContactNumber,
        Date: formatDateTimeAMPM(obj.LastModifiedDate),
        // Status: obj.IsActive === 1 ? "Active" : "InActive",
        Status: obj.ActiveStatus,
      }));

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(
          exportData,
          generateExcelColumns,
          `TwilioUserList${date + "-" + month + "-" + year}`
        );

        // Clear excel data after the download
        dispatch(dndAction.clearGetTwilioExcelDNDList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [getTwilioExcelDNDList]);
  useEffect(() => {
    if (getUserExcelDNDList?.DataList?.length > 0) {
      let generateExcelColumns = [
        "Email/Mobile",
        "Date",
        "Source",
        "Remarks",
        "Status",
        "DND Type",
      ];

      let exportData = getUserExcelDNDList?.DataList?.map((obj) => ({
        "Email/Mobile": obj.ContactNumberOrEmail,
        Date: obj.CreatedDate,
        Source: obj.InviteThrough,
        Remarks: obj.Remarks,
        Status: obj.IsActive === 1 ? "Active" : "InActive",
        "DND Type": obj.DNDStatus,
      }));

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(
          exportData,
          generateExcelColumns,
          `DNDUserList_${date + "-" + month + "-" + year}`
        );
        // Clear excel data after the download
        dispatch(dndAction.clearGetUserExcelDNDList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [getUserExcelDNDList]);

  const userDNDColumns = [
    {
      width: "220px",
      key: "ContactNumberOrEmail",
      name: "E-mail/Mobile",
      selector: (row) => row.PublicUserDNDListID,
      // cell: (row) => (
      //   <div
      //     className="Common_Link_Style"
      //     onClick={() => navigateDNDEdit(row.PublicUserDNDListID)}
      //   >
      //     {row.ContactNumberOrEmail}
      //   </div>
      // ),
      cell: (row) =>
        row.IsMUEditAccess === 0 ? (
          <span className="Common_Inactive_Style" title="Disabled-edit-access">
            {row.ContactNumberOrEmail}
          </span>
        ) : (
          <div
            className="Common_Link_Style"
            onClick={() => navigateDNDEdit(row.PublicUserDNDListID)}
          >
            {row.ContactNumberOrEmail}
          </div>
        ),
      sortable: true,
    },

    {
      key: "LastModifiedDate",
      name: "Date",
      selector: (row) => row.CreatedDate,
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">{row.CreatedDate}</div>
        </div>
      ),
      sortable: true,
    },

    {
      width: "180px",
      name: "Source",
      selector: (row) => row.InviteThrough,
      sortable: true,
      key: "InviteThrough",
    },

    {
      key: "Remarks",
      name: "Remarks",
      selector: (row) => row.Remarks,
      sortable: true,
    },
    {
      width: "90px",
      key: "ActiveStatus",
      name: "Status",
      selector: (row) => (row.IsActive === 1 ? "Active" : "Inactive"),
      sortable: true,
    },
    {
      width: "90px",
      key: "DNDStatus",
      name: "DND Type",
      selector: (row) => row.DNDStatus,
      sortable: true,
    },
  ];

  const GridformatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
      .format(date)
      .replace(",", "");
  };

  const twilioDNDColumns = [
    {
      key: "ContactNumber",
      name: "Mobile",
      selector: (row) => row.ContactNumber,
      cell: (row) => row.ContactNumber,
      sortable: true,
    },

    {
      key: "LastModifiedDate",
      name: "Date",
      selector: (row) => GridformatDate(row.LastModifiedDate),
      sortable: true,
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">
            {formatDateTimeAMPM(row.LastModifiedDate)}
          </div>
        </div>
      ),
    },

    {
      key: "ActiveStatus",
      name: "Status",
      selector: (row) => row.ActiveStatus,
      sortable: true,
    },
  ];

  const getDNDUserList = () => {
    const search = { ...DNDSearch };
    dispatch(dndAction?.getUserDNDList(search))
      .then((result) => {
        if (result?.payload?.DataList?.length === 0) {
          const searchParams = { ...DNDSearch };
          searchParams.pageNo = 1;
          searchParams.rowCountPerPage = 10;
          dispatch(dndAction?.setDNDSearch(searchParams));
          dispatch(dndAction?.getUserDNDList(searchParams));
        }
      })
      .catch((err) => { });
  };

  const getTwilioDNDList = () => {
    const updatePaginationData = { ...DNDSearch };
    updatePaginationData.rowCountPerPage = twilioPagination?.rowCountPerPage;
    updatePaginationData.pageNo = twilioPagination?.pageNo;
    dispatch(dndAction?.getTwilioDNDList(updatePaginationData));
  };

  const updateTwilioDND = () => {
    setSubmit(true);
    dispatch(dndAction?.updateTwilioDND(DNDSearch))
      .then((result) => {
        if (result?.payload?.IsSucceed) {
          // Insert Management User Activity Log
          dispatch(
            authActions?.ManagementUserActivityLog({
              ManagementUserID: user?.ManagementUserID,
              facilityID: commonFacilityCode,
              ProcedureName: StoredProcedures?.LoadTwilionumbersResult,
              UserAction: `"Loaded Twilio numbers List`,
            })
          );
          showToastNotification("DND list updated successfully", "success");
          setSubmit(false);
        } else {
          showToastNotification(
            "Something went wrong. Please try again.",
            "error"
          );
          setSubmit(false);
        }
      })
      .catch((err) => {
        showToastNotification("Failed to update Twilio DND", "error");
        setSubmit(false);
      });
  };

  //dnd user
  const dndRowPerPage = (page) => {
    const search = { ...DNDSearch, rowCountPerPage: page, pageNo: 1 };
    dispatch(dndAction.setDNDSearch(search));
  };
  const dndPageChange = (page) => {
    if (dndsorting) {
      dndsorting = false;
      return;
    }
    const search = { ...DNDSearch, pageNo: page };
    dispatch(dndAction.setDNDSearch(search));
  };

  //twilio user
  const twilioRowPerPage = (page) => {
    setTwilioPagination((prevState) => ({
      ...prevState,
      rowCountPerPage: page,
      pageNo: 1,
    }));
  };
  const twilioPageChange = (page) => {
    if (twiliosorting) {
      twiliosorting = false;
      return;
    }
    setTwilioPagination((prevState) => ({
      ...prevState,
      pageNo: page,
    }));
  };

  const handleChange = (e, input) => {
    if (input) {
      const label = e?.label;
      const value = e?.value;
      const isLabelBased = input === "InviteThrough" || input === "dndType";

      const updatedObj = {
        ...DNDSearch,
        pageNo: 1,
        rowCountPerPage: 10,
        [input]: isLabelBased ? label ?? "Both" : value ?? 2,
        ...(isLabelBased && { [input + "Value"]: value }),
      };
      dispatch(dndAction?.setDNDSearch(updatedObj));
      dispatch(dndAction?.getUserDNDList(updatedObj));
      dispatch(dndAction?.getTwilioDNDList(updatedObj));
      return;
    }
    const { name, value } = e?.target;
    //const regex = /^[a-zA-Z0-9@.\s]*$/;
    const regex = /^.*$/;
    if (!regex.test(value)) {
      return;
    }
    if (value.trim() === "" && value !== "") {
      return;
    }
    dispatch(
      dndAction?.setDNDSearch({
        ...DNDSearch,
        pageNo: 1,
        rowCountPerPage: 10,
        [name]: value,
      })
    );
  };

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    setTwilioPagination({ pageNo: 1, rowCountPerPage: 10 });
    getDNDUserList();
    getTwilioDNDList();
  };

  const handleSearchReset = () => {
    const resetSearch = {
      InviteThrough: "Both",
      InviteThroughValue: 0,
      ContactNumberOrEmail: "",
      dndType: "Both",
      dndTypeValue: 0,
      IsActive: 2,
      Remarks: "",
      pageNo: 1,
      rowCountPerPage: 10,
      exportExcel: false,
      SortBy: "",
    };
    dispatch(dndAction?.clearDNDSearch());

    setTwilioPagination((prv) => ({
      ...prv,
      pageNo: 1,
      rowCountPerPage: 10,
    }));

    dispatch(dndAction?.getUserDNDList(resetSearch));
    dispatch(dndAction?.getTwilioDNDList(resetSearch));
  };

  const navigateDNDEdit = (DndID) => {
    Swal.close();
    history.navigate("/Admin/DNDUserList/AddEdit", {
      state: { DNDID: DndID },
    });
  };

  const exportDNDUser = () => {
    const updateTotalRows = {
      ...DNDSearch,
      rowCountPerPage: userDNDList?.TotalRecordCount,
      exportExcel: true,
      pageNo: 1,
    };

    dispatch(dndAction?.getUserDNDList(updateTotalRows));
  };

  const exportTwilioUser = () => {
    const updateTotalRows = {
      ...DNDSearch,
      rowCountPerPage: userTwilioList?.TotalRecordCount,
      exportExcel: true,
      pageNo: 1,
    };

    dispatch(dndAction.getTwilioDNDList(updateTotalRows));
  };

  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    dndsorting = true;
    const search = { ...DNDSearch };
    const newSortOrder = search.SortBy?.includes(column.key)
      ? search.SortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.SortBy = `${column.key} ${newSortOrder}`;
    dispatch(dndAction?.setDNDSearch(search));
    dispatch(
      dndAction?.getUserDNDList({
        ...DNDSearch,
        SortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const handleTwillowSort = (column, sortDirection) => {
    if (!column?.key) return;
    twiliosorting = true;
    const search = { ...DNDSearch };
    const newSortOrder = search.SortBy?.includes(column.key)
      ? search.SortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.SortBy = `${column.key} ${newSortOrder}`;
    dispatch(dndAction?.setDNDSearch(search));
    setTwilioPagination((prev) => ({
      ...prev,
      SortBy: search?.SortBy,
    }));
    const updatePaginationData = { ...DNDSearch };
    updatePaginationData.rowCountPerPage = twilioPagination?.rowCountPerPage;
    updatePaginationData.pageNo = twilioPagination?.pageNo;
    updatePaginationData.SortBy = `${column.key} ${newSortOrder}`;
    dispatch(dndAction?.getTwilioDNDList(updatePaginationData));
  };

  if (loading) return <CustomLoader />;

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };
  const renderSearch = () => {
    return (
      <form onSubmit={(e) => handleSearchSubmit(e)}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                name="InviteThrough"
                label="Invite Type"
                options={DNDInviteType}
                value={DNDSearch?.InviteThrough}
                isClearable={DNDSearch?.InviteThrough !== "Both"}
                placeholder="Select Status"
                handleChange={(e) => handleChange(e, "InviteThrough")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <TextInput
                name="ContactNumberOrEmail"
                id="ContactNumberOrEmail"
                label="Email/Mobile"
                value={DNDSearch?.ContactNumberOrEmail}
                placeholder="Email/Mobile"
                handleChange={handleChange}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                name="dndType"
                label="DND Type"
                options={DNDType}
                value={DNDSearch?.dndType}
                placeholder="Select Status"
                isClearable={DNDSearch?.dndType !== "Both"}
                handleChange={(e) => handleChange(e, "dndType")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                name="IsActive"
                label="Status"
                options={dndStatus}
                value={DNDSearch?.IsActive}
                isClearable={DNDSearch?.IsActive !== 2}
                placeholder="Select Status"
                handleChange={(e) => handleChange(e, "IsActive")}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="form-floating mb-3">
              <TextAreaInput
                name="Remarks"
                id="Remarks"
                label="Remarks"
                value={DNDSearch?.Remarks}
                placeholder="Remarks"
                handleChange={handleChange}
                maxLength={50}
                rows={3}
              />
            </div>
          </div>
        </div>

        <div className="d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            variant="primary"
            className="me-2"
            label="SEARCH"
            type="submit"
            status="primary"
            disabled={false}
            icon={"search"}
          />

          <Button
            variant="secondary"
            className="me-2"
            onClick={handleSearchReset}
            label="RESET"
            type="button"
            status="secondary"
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  return (
    <>
      <div className="facility">
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
            <div className=" d-block d-md-none">
              <div
                className=" d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleInformation}
              >
                <h2 className="form_title_uppercase text-color">
                  DND USER SEARCH
                </h2>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                    }`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {/* Mobile only (Below md breakpoint) */}
            <div className="d-block d-md-none">
              {showSearchFields && renderSearch()}
            </div>

            {/* Web only (Desktop and above) */}
            <div className="mb-3 d-none d-md-block">
              <h2 className="form_title_uppercase text-color">
                DND USER SEARCH
              </h2>
            </div>
            {/* Web only (Desktop and above) */}
            <div className="d-none d-md-block">{renderSearch()}</div>
          </div>

          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3  w-100">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 resp-space">
              <h2 className="text-color">INMATE DND LIST</h2>
              <div className="d-flex flex-wrap align-items-center gap-3">
                <Button
                  variant="success"
                  className="me-2"
                  onClick={() => {
                    Swal?.close();
                    history.navigate("/Admin/DNDUserList/AddEdit", {
                      state: {},
                    });
                  }}
                  label="Add Dnd User"
                  type="button"
                  status="btn-label"
                  disabled={false}
                  imgsrc={AddIcon}
                />
                <Button
                  variant="primary"
                  className="me-2"
                  onClick={() => updateTwilioDND()}
                  label="Update Twilio Dnd"
                  type="button"
                  status="btn-label"
                  disabled={submit}
                  imgsrc={updateDND}
                />
                {userDNDList?.DataList?.length > 0 && (
                  <ExcelExport handleExcelExport={exportDNDUser} />
                )}
              </div>
            </div>

            <Table
              columns={userDNDColumns}
              data={userDNDList?.DataList}
              pagination
              onChangeRowsPerPage={dndRowPerPage}
              onChangePage={dndPageChange}
              totalRowCount={userDNDList?.TotalRecordCount}
              currentPage={DNDSearch?.pageNo}
              paginationPerPage={DNDSearch.rowCountPerPage}
              onSort={handleSort}
              serverSideSort
              sortColumn={DNDSearch?.SortBy?.split(" ")[0]}
              sortDirection={DNDSearch?.SortBy?.split(" ")[1]}
            />
          </div>

          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 resp-space">
              <h2 className="text-color">TWILIO DND LIST</h2>
              <div className="d-flex flex-wrap gap-3 align-items-center">
                {userTwilioList?.DataList?.length > 0 && (
                  <ExcelExport handleExcelExport={exportTwilioUser} />
                )}
              </div>
            </div>

            <Table
              columns={twilioDNDColumns}
              data={userTwilioList?.DataList}
              pagination
              onChangeRowsPerPage={twilioRowPerPage}
              onChangePage={twilioPageChange}
              totalRowCount={userTwilioList?.TotalRecordCount}
              currentPage={twilioPagination?.pageNo}
              paginationPerPage={twilioPagination.rowCountPerPage}
              onSort={handleTwillowSort}
              serverSideSort
              sortColumn={twilioPagination?.SortBy?.split(" ")[0]}
              sortDirection={twilioPagination?.SortBy?.split(" ")[1]}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(DNDUserList);
